import axios from "axios";
import { getCSRFToken, fetchCSRFToken } from './csrf';

const BASE_API_URL = "/api/v1";

// Get all learning paths with optional filters
export const getLearningPaths = async (filters = {}) => {
    try {
        const params = {};

        if (filters.level) {
            params.level = filters.level;
        }

        if (filters.purpose) {
            params.purpose = filters.purpose;
        }

        if (filters.page) {
            params.page = filters.page;
        }

        console.log('Fetching learning paths with params:', params);

        const response = await axios.get(`${BASE_API_URL}/learning-paths/`, {
            params,
            withCredentials: true
        });

        console.log('Learning paths response:', response.data);
        return response.data;
    } catch (error) {
        // If 403 Forbidden, user is not authenticated - return empty result
        if (error.response?.status === 403) {
            console.log('⚠️ Learning paths require authentication - returning empty result for unauthenticated user');
            return { results: [], count: 0 };
        }
        console.warn('Error fetching learning paths:', error);
        return { results: [], count: 0 };
    }
};

// Get specific learning path by ID
export const getLearningPathById = async (id, filters = {}) => {
    try {
        const params = {};

        if (filters.level) {
            params.level = filters.level;
        }

        if (filters.purpose) {
            params.purpose = filters.purpose;
        }

        console.log(`Fetching learning path ${id} with params:`, params);

        const response = await axios.get(`${BASE_API_URL}/learning-paths/${id}/`, {
            params,
            withCredentials: true
        });

        console.log('Learning path response:', response.data);
        return response.data;
    } catch (error) {
        // If 403 Forbidden, user is not authenticated
        if (error.response?.status === 403) {
            console.log(`⚠️ Learning path ${id} requires authentication`);
            return null;
        }
        console.error(`Error fetching learning path ${id}:`, error);
        throw error;
    }
};
